/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/chatbot'
export default icon
